import React from 'react';

import { Stack } from '@lyearn/ui';

import { DetailsLayoutHeroProps } from './types';

const DetailsLayoutHeroContainer: React.FC<React.PropsWithChildren<DetailsLayoutHeroProps>> = (
  props,
) => {
  const { className, children } = props;

  return (
    <Stack className={className} direction="row" gapX={56}>
      {children}
    </Stack>
  );
};

export default DetailsLayoutHeroContainer;
